import { createContext, useContext } from 'react';

import { Award } from '../../../../../../types/bonus';

export interface AwardState {
	group: string;
	hideGiver: boolean;
	isMissingSelection: boolean;
	selectedAward: Award;
	stage: Stage;
}

export enum Stage {
	Select,
	Give,
}

export interface AwardContextValue extends AwardState {
	awards: Award[];
	goToGiveAward: VoidFunction;
	goToSelectAward: VoidFunction;
	isTemplatedAward: boolean;
	setHideGiver: (hideGiver: boolean) => void;
	selectAward: (award: Award) => void;
	setIsSubmitting: (isSubmitting: boolean) => void;
}

export const AwardContext = createContext<AwardContextValue>(null as unknown as AwardContextValue);

export const useAwardModalState = () => useContext(AwardContext);
